var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4256 8.13819L7.79668 1.16609C7.62942 1.01196 7.43042 0.889632 7.21116 0.80615C6.9919 0.722668 6.75673 0.679687 6.5192 0.679687C6.28168 0.679687 6.0465 0.722668 5.82724 0.80615C5.60799 0.889632 5.40899 1.01196 5.24172 1.16609C4.9066 1.47418 4.71851 1.89095 4.71851 2.32536C4.71851 2.75978 4.9066 3.17655 5.24172 3.48464L11.6111 9.30569L5.24172 15.1267C4.9066 15.4348 4.71851 15.8516 4.71851 16.286C4.71851 16.7204 4.9066 17.1372 5.24172 17.4453C5.40984 17.5977 5.60923 17.7183 5.82845 17.8001C6.04767 17.8819 6.28241 17.9234 6.5192 17.9222C6.756 17.9234 6.99073 17.8819 7.20995 17.8001C7.42917 17.7183 7.62856 17.5977 7.79668 17.4453L11.6111 13.9592L15.4256 10.4732C15.5942 10.3203 15.7281 10.1385 15.8194 9.93808C15.9108 9.73769 15.9578 9.52277 15.9578 9.30569C15.9578 9.08862 15.9108 8.87369 15.8194 8.67331C15.7281 8.47293 15.5942 8.29106 15.4256 8.13819Z",
    fill: "#143578"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.139404 6.95645C0.139404 6.21086 0.74382 5.60645 1.4894 5.60645H10.6144C11.36 5.60645 11.9644 6.21086 11.9644 6.95645C11.9644 7.70203 11.36 8.30645 10.6144 8.30645H1.4894C0.74382 8.30645 0.139404 7.70203 0.139404 6.95645Z",
    fill: "#143578"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.139404 11.5453C0.139404 10.7997 0.74382 10.1953 1.4894 10.1953H10.6144C11.36 10.1953 11.9644 10.7997 11.9644 11.5453C11.9644 12.2909 11.36 12.8953 10.6144 12.8953H1.4894C0.74382 12.8953 0.139404 12.2909 0.139404 11.5453Z",
    fill: "#143578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.a0c2d04bcb8e786bf95d0f0ed6145e88.svg";
export { ForwardRef as ReactComponent };